//action that requests get the solicitor groups
import * as ActionTypes from "./index";

//action that gets a groups expenses case types
export function getGroupExpensesCaseTypes(payload) {
    return {
        type: ActionTypes.GET_GROUP_EXPENSES_CASE_TYPES,
        payload: payload
    }
}

//action that receives group expenses case types
export function receiveGroupExpensesCaseTypes(payload) {
    return {
        type: ActionTypes.RECEIVE_GROUP_EXPENSES_CASE_TYPES,
        payload: payload
    }
}

//action that fails to receive group expenses case types
export function failedToReceiveGroupExpensesCaseTypes(payload) {
    return {
        type: ActionTypes.FAILED_TO_RECEIVE_GROUP_EXPENSES_CASE_TYPES,
        payload: payload
    }
}

export function requestGetGroupsOfSolicitors() {
    return {
        type: ActionTypes.REQUEST_GET_GROUPS_OF_SOLICITORS
    }
}

//action that receives the solicitor groups
export function receiveSolicitorGroups(groups) {
    return {
        type: ActionTypes.RECEIVE_GROUPS_OF_SOLICITORS,
        payload: groups
    }
}

//action that receives failed request from fetching the solicitor groups
export function failedToGetGroupsOfSolicitors(response) {
    return {
        type: ActionTypes.FAILED_TO_GET_GROUPS_OF_SOLICITORS,
        payload: response
    }
}


//action that requests get specific solicitor group
export function requestGetSpecificSolicitorGroup(groupId) {
    return {
        type: ActionTypes.REQUEST_GET_SPECIFIC_SOLICITOR_GROUP,
        payload: groupId
    }
}

//action that receives get specific solicitor group
export function receiveGetSpecificSolicitorGroup(group) {
    return {
        type: ActionTypes.RECEIVE_GET_SPECIFIC_SOLICITOR_GROUP,
        payload: group
    }
}

//action that receives bad request getting specific solicitor group
export function receiveBadRequestGetSpecificSolicitorGroup(response) {
    return {
        type: ActionTypes.RECEIVE_BAD_REQUEST_GET_SPECIFIC_SOLICITOR_GROUP,
        payload: response
    }
}


//action that requests get underwriter of specific solicitor group
export function requestGetUnderwriterOfSpecificSolicitorGroup(groupId) {
    return {
        type: ActionTypes.REQUEST_GET_UNDERWRITER_OF_SPECIFIC_SOLICITOR_GROUP,
        payload: groupId
    }
}

//action that receives get underwriter of specific solicitor group
export function receiveGetUnderwriterOfSpecificSolicitorGroup(group) {
    return {
        type: ActionTypes.RECEIVE_GET_UNDERWRITER_OF_SPECIFIC_SOLICITOR_GROUP,
        payload: group
    }
}

//action that receives bad request getting  underwriter of specific solicitor group
export function receiveBadRequestGetUnderwriterOfSpecificSolicitorGroup(response) {
    return {
        type: ActionTypes.RECEIVE_BAD_REQUEST_GET_UNDERWRITER_OF_SPECIFIC_SOLICITOR_GROUP,
        payload: response
    }
}

//action that requests the case types of a specific solicitor group
export function getSolicitorGroupCaseTypes(groupId) {
    return {
        type: ActionTypes.GET_SOLICITOR_GROUP_CASE_TYPES,
        payload: groupId
    }
}

//action that receives case types of a specific solicitor group
export function receiveSolicitorGroupCaseTypes(caseTypes) {
    return {
        type: ActionTypes.RECEIVE_SOLICITOR_GROUP_CASE_TYPES,
        payload: caseTypes
    }
}

//action that receives failed response from requesting case types of a solicitor group
export function failedToReceiveSolicitorGroupCaseTypes(response) {
    return {
        type: ActionTypes.FAILED_TO_RECEIVE_SOLICITOR_GROUP_CASE_TYPES,
        payload: response
    }
}

//action that requests patch selected solicitor group
export function patchSolicitorGroup(groupId,patchedGroup) {
    return {
        type: ActionTypes.PATCH_SOLICITOR_GROUP,
        payload: {
            key: groupId,
            value: patchedGroup
        }
    }
}


//action that receives patch selected solicitor group response
export function receiveResponsePatchSolicitorGroup(response){
    return {
        type: ActionTypes.RECEIVE_RESPONSE_PATCH_SELECTED_SOLICITOR_GROUP,
        payload: response
    }
}

//action that receives bad request patch selected solicitor group response
export function failedPatchSolicitorGroup(response){
    return {
        type: ActionTypes.FAILED_PATCH_SOLICITOR_GROUP,
        payload: response
    }
}
